var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-follow-up-progress",attrs:{"aria-label":`${_vm.processed} of ${_vm.total} follow-ups processed`}},_vm._l((_vm.total),function(index){return _c('span',{key:index,class:`lead-follow-up-progress__segment--${_vm.segmentState(index)}`})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }